module.exports = __webpack_public_path__ + "img/noAuth.538a421d.png";